import { APP_URL_HERMES, PUSHER_APP_KEY_HERMES, PUSHER_HOST_HERMES } from '../constants/nofitications';
import type { ToolbarEchoParams } from './getToolbarEchoConfig';

/**
 * API + Echo para notificações. Sobrescreva com `VITE_APP_URL`, `VITE_PUSHER_APP_KEY`, `VITE_PUSHER_HOST`.
 */
const TOOLBAR_NOTIFICATIONS_DEFAULTS = {
    appUrl: APP_URL_HERMES ?? 'https://hermes.empreender.plus',
    pusherKey: PUSHER_APP_KEY_HERMES ?? 'hermes-prod',
    pusherHost: PUSHER_HOST_HERMES ?? 'ws.hermes.empreender.plus',
} as const;

function stripTrailingSlash(url: string): string {
    return url.replace(/\/$/, '');
}

export function resolveToolbarNotificationsConnection(bearerToken: string | null | undefined): {
    apiBaseUrl: string;
    echoParams: ToolbarEchoParams | null;
} {
    const rawBearer = typeof bearerToken === 'string' ? bearerToken.trim() : '';
    const appUrl = stripTrailingSlash(String(TOOLBAR_NOTIFICATIONS_DEFAULTS.appUrl));
    const pusherKey = TOOLBAR_NOTIFICATIONS_DEFAULTS.pusherKey;
    const pusherHost = TOOLBAR_NOTIFICATIONS_DEFAULTS.pusherHost;

    if (!rawBearer || !appUrl || !pusherKey || !pusherHost) {
        return { apiBaseUrl: appUrl, echoParams: null };
    }

    return {
        apiBaseUrl: appUrl,
        echoParams: {
            appUrl,
            pusherKey,
            pusherHost,
            bearerToken: rawBearer,
        },
    };
}
